import React, { useState } from 'react';
import * as IoC from 'typescript-ioc';
import { DateFnsFormats } from '../../../../../infrastructure/date-formatter';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';

import { Popover } from '../../../../global/popover/popover';

import ColumnWithUnavailableMark from '../../../../global/column-with-unavailable-mark/column-with-unavailable-mark';
export interface IProps {
    isCancelled: boolean;
    cancelDateTime?: string;
    eventTimezone: string;
    listItemRef: React.MutableRefObject<HTMLElement>;
}

const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);


const ConnectionDeleteDetails = (props: IProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const {
        isCancelled = false,
        cancelDateTime,
        eventTimezone,
        listItemRef
    } = props;

    const cancelDate = new Date(cancelDateTime);
    const time = isCancelled && dateTimeFormatter.dateToFormattedString(cancelDate, dateTimeFormatter.getLocalTimeFormat());
    const date = isCancelled && dateTimeFormatter.dateToFormattedString(cancelDate, DateFnsFormats.StringifiedFullDayMonthNumericDateYear, eventTimezone);

    const itemWidth = 198;

    const handleOpenPopover = e => {
        e.stopPropagation();
        setIsOpen(prev => !prev);
    };

    return (
        <div style={{position: 'relative'}}>
            <ColumnWithUnavailableMark isCancelled={isCancelled} handleOpenPopover={handleOpenPopover}/>
            <Popover
                isOpen={isOpen}
                buttonRef={listItemRef}
                onClickOutside={() => setIsOpen(false)}
                customWidth={itemWidth}
                padding={4}
                align='start'
            >
                <div className='w-100' onClick={e => e.stopPropagation()}>
                    <div className='connection-list__popover' style={{color: '#ee0000', textAlign: 'center'}}>
                        {`This Zoom Meeting was deleted at ${time} on ${date}`}
                    </div>
                </div>
            </Popover>
        </div>);
};

export { ConnectionDeleteDetails };


